import { useTranslation } from '@/lib/i18n';
import { createFileRoute } from '@tanstack/react-router';
import MarkEmailReadIcon from '~icons/material-symbols/mark-email-read-outline';
import BotaoTour from './-botao-tour';
import LayoutTesteGratis from './-layout';

export const Route = createFileRoute(
  '/__public/novo-cliente/verifique-seu-email',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation('public');

  return (
    <LayoutTesteGratis className="max-w-md">
      <div className="mt-6 flex flex-col items-center gap-5 rounded-xl border bg-card p-8 text-center text-card-foreground shadow-sm">
        <div className="rounded-full bg-primary/10 p-4 text-primary">
          <MarkEmailReadIcon className="size-10" />
        </div>

        <div className="space-y-2">
          <h1 className="text-xl font-semibold">
            {t($ => $.testeGratis.verifiqueSeuEmail.titulo)}
          </h1>
          <p className="text-muted-foreground">
            {t($ => $.testeGratis.verifiqueSeuEmail.descricao)}
          </p>
        </div>

        <BotaoTour />
      </div>
    </LayoutTesteGratis>
  );
}
